import { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/routers/constant'

const router: Array<RouteRecordRaw> = [
  {
    path: '/business/stats',
    component: Layout,
    redirect: '/business/stats/clinic/overview/index',
    meta: {
      title: '统计管理',
      keepAlive: true,
      requiresAuth: true
    },
    children: [
      {
        path: 'clinic/overview/index',
        name: 'BusinessStatsClinicOverViewIndex',
        component: () => import('@/views/business/stats/clinic/overview/index.vue'),
        meta: {
          keepAlive: true,
          requiresAuth: true,
          title: '经营概况'
        }
      },
      {
        path: 'clinic/feedback/index',
        name: 'BusinessStatsClinicFeedbackIndex',
        component: () => import('@/views/business/stats/clinic/feedback/index.vue'),
        meta: {
          keepAlive: true,
          requiresAuth: true,
          title: '投诉建议'
        }
      },
      {
        path: 'clinic/report/index',
        name: 'BusinessStatsClinicReportIndex',
        component: () => import('@/views/business/stats/clinic/report/index.vue'),
        meta: {
          keepAlive: true,
          requiresAuth: true,
          title: '报告解读'
        }
      }
    ]
  }
]

export default router
